import { useState, useEffect, memo } from "react"
import { DateRangePicker, SelectPicker, Dropdown, Input } from 'rsuite';
import { startOfDay, endOfDay, addDays, startOfWeek, endOfWeek, startOfMonth, endOfMonth, startOfYear, endOfYear } from "date-fns";
import { Link } from "react-router-dom"
import { Row, Col } from "react-bootstrap"
import axiosService from "../../../utils/axios.service";
import { format } from "date-fns"
import { Button } from 'antd';
import 'antd/dist/antd.min.css'
import { headerReport } from "../../../enums/headerReport.enum";
import * as convert from "../../constant/Convert.helper";
import _ from "lodash";


const Search = ({ startDate, endDate, handleRangeDate, store, handleStore, handleUser, handleEmulation, handleSearchVoucher, sortBy, handleSortBy,
    title, type, isExport, csvData, handleExportData, header, fileName, userAdmin, onChangeKeyword, emulation}) => {
    const [locations, setLocations] = useState([])
    const locationsWidth = window.innerWidth

    const [keyword, setKeyword] = useState('')
    let startOfWeek1 = startOfWeek(new Date())
    let endOfWeek1 = endOfWeek(new Date())
    let ranges = [
        {
            label: "Hôm qua",
            value: [
                startOfDay(addDays(new Date(), -1)),
                endOfDay(addDays(new Date(), -1)),
            ],
        },
        {
            label: "Hôm nay",
            value: [startOfDay(new Date()), endOfDay(new Date())],
        },
        {
            label: "Tuần này",
            value: [addDays(startOfWeek1, 1), addDays(endOfWeek1, 1)],
        },
        {
            label: "Tuần trước",
            value: [addDays(startOfWeek(addDays(startOfWeek1, -1)), 1), addDays(endOfWeek(addDays(startOfWeek1, -1)), 1)],
        },
        {
            label: "Tháng này",
            value: [startOfMonth(new Date()), endOfMonth(new Date())],
        },
        {
            label: "Tháng trước",
            value: [startOfMonth(addDays(startOfMonth(new Date()), -1)), endOfMonth(addDays(startOfMonth(new Date()), -1))],
        },
        {
            label: "Năm này",
            value: [startOfYear(new Date()), endOfDay(endOfYear(new Date()))],
        },
        {
            label: "Năm trước",
            value: [startOfYear(addDays(startOfYear(new Date()), -1)), endOfYear(addDays(startOfYear(new Date()), -1))],
        },
    ]
    let rangesNv = [
        {
            label: "Hôm qua",
            value: [
                startOfDay(addDays(new Date(), -1)),
                endOfDay(addDays(new Date(), -1)),
            ],
        },
        {
            label: "Hôm nay",
            value: [startOfDay(new Date()), endOfDay(new Date())],
        },
        {
            label: "Tuần này",
            value: [addDays(startOfWeek1, 1), addDays(endOfWeek1, 1)],
        },
        {
            label: "Tuần trước",
            value: [addDays(startOfWeek(addDays(startOfWeek1, -1)), 1), addDays(endOfWeek(addDays(startOfWeek1, -1)), 1)],
        },
        {
            label: "Tháng này",
            value: [startOfMonth(new Date()), endOfMonth(new Date())],
        },
        {
            label: "Tháng trước",
            value: [startOfMonth(addDays(startOfMonth(new Date()), -1)), endOfMonth(addDays(startOfMonth(new Date()), -1))],
        },
    ]
    useEffect(() => {
        if (["daily", "customers", "emulation", "users", "products", "sales", "total-sales-online", "ktv-tvv", "detail-ktv-tvv", "hopper"].includes(type)) {
            fetchLocations()
        }
        if (type == 'detail_promotion') {
            fetchGroupVoucher()
        }
    }, [sortBy])

    const onChangeDate = (e) => {
        if (e) {
            const eDate = format(e[1], 'yyyy-MM-dd')
            const sDate = format(e[0], 'yyyy-MM-dd')
            handleRangeDate(sDate, eDate)
        }
    }

    const fetchLocations = async () => {
        if (userAdmin && [3].includes(userAdmin.role)) {
            let dataStore = convert.getStoreByRole(userAdmin)
            setLocations([...dataStore])
        } else {
            var rs = await axiosService("api/users/store/" + store + "?type=1", "GET")
            if (type == 'sales') {
                var rs = await axiosService("api/users/store/" + store +"?role=5", "GET")
            } else {
                var rs = await axiosService("api/users/store/" + store, "GET")
            }
            if (type == "hopper") {
                 rs = await axiosService("api/stores", "GET")
                 const { data } = rs
                if (data.code === 200) {
                    data.data.unshift({ name_store: "Tất cả", id: 0 })
                    const newLocations = data.data.map(x => {
                        return { label: x.name_store, value: x.id }
                    })
                    setLocations([...newLocations])
                }
            } else {
                const { data } = rs
                if (data.code === 200) {
                    const newLocations = data.data.map(x => {
                        return { label: x.name, value: x.id }
                    })
                    if (type == "emulation") {
                        setLocations([{label: "Tất cả", value: 0},...newLocations])
                    } else {
                        setLocations([...newLocations])
                    }
                }
            }
        }
    }

    const fetchGroupVoucher = async () => {
        const rs = await axiosService("api/category_voucher", "GET")
        const { data } = rs
        if (data.code === 200) {
            data.data.unshift({ group_name: "Tất cả", id: 0 })
            const newLocations = data.data.map(x => {
                return { label: x.group_name, value: x.id }
            })
            setLocations([...newLocations])
        }
    }

    const onChangeKeywordHeader = _.debounce((e) => {
        if (e.length > 3 || e.length == 0) {
            setKeyword(e)
            onChangeKeyword(e)
        }
    }, 1000)

    const onChangeUser = (e) => {
        for (let item of locations) {
            if (item.value == e) {
                handleUser(item)
            }
        }
    }

    const onChangeEmulation = (e) => {
        for (let item of emulation) {
            if (item.value == e) {
                handleEmulation(item)
            }
        }
    }

    const handleExport = () => {
        handleExportData()
    }
    return (
        <div className="search-report">
            <Row>
                <Col xs={12} md={4}>
                    {[1].includes(userAdmin.role) ?
                        <Dropdown title={title}>
                        {
                            headerReport.map((x, i) => {
                                return (
                                    <Link to={{ pathname: `/report/${x.route}` }} key={i}>
                                        <Dropdown.Item >
                                            <i className={`${x.icon} mr-1`}></i><span>{x.label}</span> {type === x.route && <i className="ml-2 fa-solid fa-check"></i>}
                                        </Dropdown.Item>
                                    </Link>
                                )
                            })
                        }
                        </Dropdown>
                    : null}
                </Col>
                <Col xs={12} md={8}>
                    <Row className="justify-content-end">
                        {[1,4,8].includes(userAdmin.role) ?
                            <Col xs={12} md={3} xl={3} className="mb-2">
                                {["detail-ktv-tvv", "sales", "emulation",  "hopper"].includes(type) &&
                                    <SelectPicker style={{ width: 260 }} menuStyle={{ width: 260 }} data={locations} defaultValue={userAdmin.id} onChange={onChangeUser}/>
                                }
                            </Col>
                        : null }
                         {type == "emulation" || type == "hopper"? 
                                <Col xs={12} md={3} xl={3} className="mb-2">
                                    {["emulation", "hopper"].includes(type) &&
                                        <SelectPicker data={emulation} className="w-100" defaultValue={0} onChange={onChangeEmulation}/>
                                    }
                                </Col>
                         : null}
                        
                        {type != "emulation" && type != "hopper" && type != 'detail-ktv-tvv' ? 
                            <Col xs={12} md={3} xl={3}  className="mb-2">
                                <Input data={keyword} placeholder="Tìm kiếm theo keyword" className="w-200" onChange={onChangeKeywordHeader} />
                            </Col>
                        : null}

                        {type != "emulation" ? 
                            <Col xs={12} md={5} xl={4} className="mb-2">
                                <DateRangePicker
                                    className="w-100"
                                    placement={"bottomEnd"}
                                    format="yyyy-MM-dd"
                                    onChange={onChangeDate}
                                    ranges={type != 'detail-ktv-tvv' ? ranges : rangesNv}
                                    defaultValue={[new Date(startDate), new Date(endDate)]}
                                    showOneCalendar={locationsWidth < 768}
                                />
                            </Col>
                        : null}
                        {type == 'hopper' &&
                                <Col xs={6} md={2} xl={2} style={{ textAlign: "right" }}  className="mb-2">
                                    <Button size="middle" type="primary"
                                        onClick={handleExport}
                                    ><i className="fa-solid fa-file-excel mr-2"></i>Xuất dữ liệu
                                    </Button>
                                </Col>
                            }

                    </Row>
                </Col>
            </Row>
        </div>
    )
}
export default memo(Search)